var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"protocol-chart"},[(_vm.title)?_c('div',{staticClass:"chart-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{ref:"chartContainer",staticClass:"chart-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }